import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function DropIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16.6784 1.27094C16.2227 0.909687 15.579 0.909687 15.1233 1.27094C14.6677 1.63282 3.95572 10.2398 3.95572 19.0555C3.95572 25.6418 9.31389 31 15.9002 31C22.4865 31 27.8447 25.6418 27.8447 19.0555C27.8447 10.2398 17.134 1.63282 16.6784 1.27094ZM16.8384 26.3125C16.1484 26.3125 15.5883 25.7524 15.5883 25.0624C15.5883 24.3724 16.1484 23.8124 16.8384 23.8124C18.7334 23.8124 20.2759 22.2699 20.2759 20.3749C20.2759 19.6849 20.8359 19.1249 21.5259 19.1249C22.2159 19.1249 22.7759 19.6849 22.7759 20.3749C22.7759 23.6487 20.1121 26.3125 16.8384 26.3125Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
